<div  class="sub-menu">
    <div class="col">
        <a (click)="onclicked()" [routerLink]="['/login']" routerLinkActive="active-link" [routerLinkActiveOptions]="{exact:true}">Vacancy Login <img  src="../../../assets/icons/icon-tenant.svg" alt=""/></a>
        <a (click)="onclicked()" [routerLink]="['/register-vacancy-schedule']" routerLinkActive="active-link" [routerLinkActiveOptions]="{exact:true}">Register for vacancy schedule <img  src="../../../assets/icons/icon-broker.svg" alt=""/></a>
    </div>   
</div>